import {Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DatePipe} from "@angular/common";
import Timestamp = firebase.firestore.Timestamp;
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {environment} from "../../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {UploadModel} from "../../../../models/UploadModel";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {MatSnackBar} from "@angular/material/snack-bar";
import firebase from "firebase/compat/app";

@Component({
    selector: 'app-view-individual-assessment',
    templateUrl: './view-individual-assessment.component.html',
    styleUrls: ['./view-individual-assessment.component.scss']
})
export class ViewIndividualAssessmentComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  env = isDevMode() ? environment.testMode : environment.productionMode
mDocuments:UploadModel[]=[]
  mDbType: 'realtime' | 'firestore' = 'firestore';
    mStoragePath?: string = 'counselling/individual-sessions'
    mPath = this.env.counseling;
    documents$: Observable<unknown | undefined>


    constructor(
        private readonly matDialogRef: MatDialogRef<ViewIndividualAssessmentComponent>,
        private readonly datePipe: DatePipe,
        private readonly mStorage:AngularFireStorage,
        private readonly mFirestore:AngularFirestore,
        private readonly _snackBar:MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        console.log(data)
        this.mStoragePath = this.mStoragePath + '/' + data.id
        this.mPath =this.env.documents+'/'+ this.mPath + '/individualSessions/' + data.id
        console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)

        // Stamp root-level metadata so the photo gallery can query by date & centre
        const sessionDate = data.date || data.sessionDate || null;
        this.mFirestore.doc(this.mPath).set({
          date:       sessionDate,
          dateAdded:  sessionDate,
          centreCode: data.centreCode || '',
          centreName: data.centreName || '',
        }, { merge: true });

        this.documents$  = this.mFirestore.doc( this.mPath).valueChanges({idField:'id'})
    this.documents$.pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      // @ts-ignore
      this.mDocuments = res.documents as UploadModel
    })
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    getTopicsCovered(centres: any[]): string {
        let str = ''
        centres.forEach(it => {
            str += it + ', '
        })
        return str
    }

    getDate(date: Timestamp) {
        return this.datePipe.transform(date.toDate(), 'dd-MMM-yyyy')
    }

    getTime(date: Timestamp) {
        let dt = date.toDate()
        return this.datePipe.transform(date.toDate(), 'shortTime')
        // return dt.get()
    }

    trackByMethod(index: number, el: any): number {
        return el.id;
    }

    openLink(fileUrl: string) {
        window.open(fileUrl)

    }

    @needConfirmation()
    deleteAdmissionFile(i: number, d: UploadModel, category: string) {
        const iRef = this.mStorage.storage.refFromURL(d.url)
        iRef.delete().then(() => {
            this.mFirestore.doc(this.mPath).update({
                [category]: firebase.firestore.FieldValue.arrayRemove(d)
            }).then(() => {
                this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
            })
        })
        console.log(iRef)
    }
}
